import React, { useState, useContext, useEffect, useRef } from 'react';
import "./DropDown.css";

let DropDown = (props) => {
	const [on, setOn] = useState(false);
	const myDropDown = useRef(null);
	useEffect(() => {
		document.body.addEventListener('click', (event) => {
			if (event.target.offsetParent != myDropDown.current) {
				setOn(false)
			}
		});
	},[]);
	return (
		<div>
			<div class={on ? "DropMenu on" : "DropMenu"} 
				data-position={ props.position }
				
				ref={myDropDown}
				>
				<a onClick={() => setOn(!on)}>{ props.label }<span></span></a>
				<div class={ props.featureClass }>
					<ul>
						{ props.children }
					</ul>
				</div>
			</div>
		</div>
	)
}

export default DropDown;